import { useState } from "react";
import { updateEmisionStep } from "../../../../Services/API/bff/auto";
import { autoViaBffDesdeConfig } from "../../../../Services/API/bff/auto/flag";
import { seleccionarPlan } from "../../../../Services/API/bff/auto/funnel";
import { aBffError, BffError } from "../../../../Services/API/bff/auto/bffError";
import { mensajeDeError } from "../../../../Services/API/bff/auto/errorMessages";
import { RechazoEmbudo } from "../Emision/RechazoEmbudo";
import { useConfig } from "../../../../context/ConfigContext";
import { Cotizacion } from "../../../../Pages/Auto/Precios";
import { useEmisionStore } from "../../../../Services/Providers/EmisionStore";
import { useGraciasStore } from "../../../../Services/Providers/GraciasStore";
import { useNavigate, useParams } from "react-router-dom";
import { useConfiguracionEmpresa } from "../../../../Services/Providers/useConfiguracionEmpresa";
import { useCotizacionStore } from "../../../../Services/Providers/CotizacionStore";

interface Props {
    rubro: string;
    cotizacion: Cotizacion;
    styles?: React.CSSProperties;
    href?:string;
    /** Solo /retomar: precios vencidos, no se puede contratar hasta actualizarlos. */
    deshabilitado?: boolean;
    /** Solo /retomar: trae los datos de la persona antes de seleccionar. false = no sigue. */
    antesDeContratar?: (itemId: string) => Promise<boolean>;
    /** Solo /retomar: la selección falló; true = la pantalla lo resuelve y no se navega. */
    alFallarSeleccion?: (error: BffError) => boolean;
}

export const ButtonContratar = ({ rubro, cotizacion, styles = {}, href, deshabilitado = false, antesDeContratar, alFallarSeleccion }: Props) => {

    const { emisionValues, setEmisionValues } = useEmisionStore();
    const cotizacionValues = useCotizacionStore(state => state.cotizacionValues);
    const { setGraciasValues } = useGraciasStore();
    const { origen, config } = useConfiguracionEmpresa();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    /** 422 del embudo al elegir el plan: no se sigue a la emision. */
    const [rechazoEmbudo, setRechazoEmbudo] = useState<string>();
    const navigate = useNavigate();
    const { compania } = useParams();
    const { config: envConf } = useConfig();
    const viaBff = autoViaBffDesdeConfig(envConf);

    const setDescription = () => {
        const nuevaDesc: any = {
            id: cotizacion.id,
            amountMonth: cotizacion.premio,
            companyLogo: cotizacion.LogoCompania,
            companyName: cotizacion.NombreCompania,
            codCompany: cotizacion.CodigoCompania,
            descList: cotizacion.descripciones,
            discountAmount: cotizacion.PrecioSinDescuento,
            discountPerc: cotizacion.DescuentoPorcentaje,
            fiscalInfoImg: cotizacion.Afip,
            nombreCompania: cotizacion.NombreCompania,
            planName: cotizacion.nombreCobertura,
            sumaAsegurada: cotizacion.SumaAsegurada,
            vtvRequerida: cotizacion.vtvRequerida
        };
        setEmisionValues({
            ...emisionValues,
            cotizacionDesc: nuevaDesc,
        });
    };

    const handleClick = async (e: any, direccion: string, gracias: boolean = false) => {
        e.preventDefault();
        if (isLoading || deshabilitado) return
        setIsLoading(true)

        if (antesDeContratar && !(await antesDeContratar(String(cotizacion.id)))) {
            setIsLoading(false)
            return
        }

        let destino = direccion;
        let derivaAGracias = gracias;
        setRechazoEmbudo(undefined)

        if (viaBff) {
            // El BFF decide si se puede emitir online: la respuesta de
            // selección manda sobre lo que muestre la card.
            try {
                const seleccion = await seleccionarPlan(
                    rubro.toLowerCase() === "moto" ? "moto" : "auto",
                    String(cotizacion.id)
                );
                if (!seleccion.emisionOnline.habilitada) {
                    derivaAGracias = true;
                    destino = compania
                        ? `/${rubro.toLocaleLowerCase()}/gracias/${compania}`
                        : `/${rubro.toLocaleLowerCase()}/gracias/`;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn("[auto_via_bff] selección:", aBffError(error).code);
                // Embudo EOL (US 23704): Salesforce rechazo cotizacion_elegida. Frena.
                if (aBffError(error).code === "embudo_rechazado") {
                    setRechazoEmbudo(mensajeDeError(aBffError(error)))
                    setIsLoading(false)
                    return
                }
                // Solo /retomar: un rechazo que la pantalla resuelve (p. ej. precios vencidos) corta acá.
                if (alFallarSeleccion?.(aBffError(error))) {
                    setIsLoading(false)
                    return
                }
            }
        } else {
            //if (origen === "SEGURARSE") {
            await updateEmisionStep(0, {
                idItemCotizacion: cotizacion.id || null,
                contactoId: cotizacionValues.contactoId,
            } as any)
            //}
        }

        setDescription();
        setIsLoading(false)
        if (derivaAGracias) {
            setGraciasValues(cotizacion.NombreCompania)
        }

        navigate(destino);
    }


    return (
        <>
            {(cotizacion?.id == null || origen !== "SEGURARSE")
                ?
                <a
                    href={
                        href ? href :
                        compania ? (`/${rubro.toLocaleLowerCase()}/gracias/` + compania) : `/${rubro.toLocaleLowerCase()}/gracias/`}
                    type="button"
                    onClick={(e) =>
                        handleClick(e, 
                            (
                            href ? href :
                            compania ? (`/${rubro.toLocaleLowerCase()}/gracias/` + compania) 
                            : `/${rubro.toLocaleLowerCase()}/gracias/`), true)
                    }
                    className={`btn btn-primary fs-16${deshabilitado ? " disabled" : ""}`}
                    aria-disabled={deshabilitado || undefined}
                    style={origen !== "SEGURARSE" ? { ...styles, backgroundColor: config.colors.primary } : styles}>
                    <span>{"CONTRATAR"}</span>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm " role="status">
                            <span className="sr-only" />
                        </div>
                    }
                </a>
                :
                <a
                    href={`/${rubro.toLocaleLowerCase()}/emision/revision`}
                    type="button"
                    className={`btn btn-primary fs-16${deshabilitado ? " disabled" : ""}`}
                    aria-disabled={deshabilitado || undefined}
                    onClick={(e) => handleClick(e, `/${rubro.toLocaleLowerCase()}/emision/revision`)}
                    style={{ ...styles }}
                >
                    <span>{"CONTRATAR"}</span>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm " role="status">
                            <span className="sr-only" />
                        </div>
                    }
                </a>
            }
            <RechazoEmbudo mensaje={rechazoEmbudo} />
        </>
    )
}
